import Vue, { VueConstructor } from 'vue';
import _ from 'lodash';
import { gameStore } from '@/store/game/store';
import { Client } from '@/client';
import { Action, Card } from '@/store/game';
import { getCardFilename } from '@/functions';
import { ElInput } from 'element-ui/types/input';
import TopBanner from "./TopBanner.vue";
import Notebook from "./Notebook.vue";
import TableItems from "./TableItems.vue";
import PlayerCards from "./PlayerCards.vue";
import Counters from "./Counters.vue";
import QuestionChoiceDlg from "./QuestionChoiceDlg.vue";
import MyGlasses from "./MyGlasses.vue";
import InformantDlg from "./InformantDlg.vue";
import AccuseDlg from "./AccuseDlg.vue";
import NeedGlass from "./NeedGlass.vue";
import ConfirmTakeGlass from "./ConfirmTakeGlass.vue";
import InfoDialogs from "./InfoDialogs.vue";
import GameBroken from "./GameBroken.vue";

export default (Vue as VueConstructor<Vue & {
    $refs: {
        gameLink: HTMLInputElement,
        gameLog: ElInput
    };
}>).extend({
    data() {
        return {
            showTooltip1: false,
            notes: ""
        };
    },
    computed: {
        joined(): boolean {
            return !!gameStore.state.gid;
        },
        gameLink(): string {
            return window.location.href.split('?')[0] + "?gid=" + gameStore.state.gid;
        },
        isOwner() {
            return gameStore.state.isOwner;
        },
        gameStarted() {
            return gameStore.state.gameStarted;
        },
        notesRows() {
            return window.innerHeight < 800 ? 7 : 10;
        },
        players() {
            return gameStore.state.players;
        },
        sortedPlayers() {
            return gameStore.state.sortedPlayers;
        },
        gameLog() {
            return gameStore.state.gameLog;
        },
        secretCards() {
            return gameStore.state.secretCards;
        },
        myTurn() {
            return gameStore.state.currentPlayerId == gameStore.state.playerInfo.id;
        },
        gameBroken() {
            return !!gameStore.state.playerLeft;
        }
    },
    methods: {
        copyLink(input: HTMLInputElement) {
            input.select();
            input.setSelectionRange(0, 99999);
            /*For mobile devices*/
            document.execCommand("copy");
            if (input.name == "game") this.showTooltip1 = true;
            this.$nextTick(() => {
                this.showTooltip1 = false;
            });
        },
        newGame() {
            window.location.href = window.location.href.split('?')[0];
        },
        start() {
            Client.getInstance().send({
                action: Action.start
            })
        },
        getCardFilename: (card: Card) => getCardFilename(card)
    },
    updated() {
        if (!this.$refs.gameLog) return;
        const gameLogTextarea = this.$refs.gameLog.$el.querySelector("textarea")!;
        gameLogTextarea.scrollTop = gameLogTextarea.scrollHeight;
    },
    components: {
        TopBanner,
        Notebook,
        TableItems,
        PlayerCards,
        Counters,
        QuestionChoiceDlg,
        MyGlasses,
        InformantDlg,
        AccuseDlg,
        NeedGlass,
        ConfirmTakeGlass,
        InfoDialogs,
        GameBroken
    }
})